import styled from 'styled-components';
import type {
  StyledObject,
} from 'styled-components';

import type {
  InputComponentProps,
  InputComponent,
} from '../types';

export const Input: InputComponent = styled.input<InputComponentProps>(({
  $hasError,
  $hasWarning,
}) => {
  const res: StyledObject<object> = {
    width: '100%',
    boxSizing: 'border-box',
  };

  if ($hasError) {
    res.borderColor = '#d64c4c';
    res.backgroundColor = '#fdf6f6';
  } else if ($hasWarning) {
    res.borderColor = '#eea505';
    res.backgroundColor = '#fdf6e6';
  }

  return res;
});
